import React, { useEffect, useState } from 'react';
import { JsonViewer } from '@textea/json-viewer';
import { Category, TenantHierarchy } from '@app/models';
import { addCategoryAndOuNamesToRules } from './AggregatedConfigRules';

import { useConfigRule } from '@app/sdk';
import { ComponentErrorBoundary } from '@app/utilities';

export function ConfigRulesByCategory({
  ouId,
  categoryId,
  categories,
  tenantHierarchy,
}: {
  ouId: string;
  categoryId: string;
  categories: Category[];
  tenantHierarchy: TenantHierarchy;
}) {
  const [filteredRules, setFilteredRules] = useState(undefined as any);
  const { data: rules, isLoading } = useConfigRule({ ouId });

  useEffect(() => {
    const rulesWithCategoryAndOuNames = addCategoryAndOuNamesToRules(
      (rules?.map &&
        rules?.map((rule) => ({
          ...rule,
          organisationUnitId: ouId,
        }))) ||
        [],
      categories,
      tenantHierarchy
    );
    setFilteredRules(
      rulesWithCategoryAndOuNames?.filter((rule: any) => categoryId === 'all' || rule.category === categoryId)
    );
  }, [categoryId, rules, categories, tenantHierarchy, ouId]);

  return (
    <ComponentErrorBoundary>
      {isLoading && <div className="ui active centered inline loader" />}
      {!isLoading && filteredRules && <JsonViewer value={filteredRules} />}
    </ComponentErrorBoundary>
  );
}
